import type { RequestOptions } from './RequestOptions';
import type MailboxRequestOptions from './MailboxRequestOptions';
import isExplicitLogonRequest from './isExplicitLogonRequest';

export function isAuthNeeded(requestOptions: RequestOptions | MailboxRequestOptions): boolean {
    if (!requestOptions) {
        return true;
    }

    return (
        !isExplicitLogonRequest(requestOptions) && requestOptions.authNeededOnUnAuthorized !== false
    );
}
